import { defineComponent as Q, ref as E, watch as F, computed as u, openBlock as r, createElementBlock as c, createCommentVNode as f, createBlock as n, normalizeClass as h, normalizeStyle as X, createElementVNode as x, Fragment as p, renderList as k, withCtx as y, createTextVNode as z, toDisplayString as b } from "vue";
import { EPaginationSize as g, EPaginationVariant as N, EPaginationColor as w, EPaginationShape as S } from "./novoui-vuejs61.js";
import { NovoButtonVariant as U } from "./novoui-vuejs50.js";
import m from "./novoui-vuejs2.js";
import Y from "./novoui-vuejs13.js";
import { range as C } from "./novoui-vuejs802.js";
const Z = { class: "pagination-container" }, ee = {
  key: 0,
  class: "pagination-counter-label"
}, ae = { class: "pagination" }, se = /* @__PURE__ */ Q({
  __name: "NPagination",
  props: {
    size: {
      type: String,
      required: !1,
      default: g.sm
    },
    variant: {
      type: String,
      required: !1,
      default: N.outlineSubtle
    },
    color: {
      type: String,
      required: !1,
      default: w.primary
    },
    shape: {
      type: String,
      required: !1,
      default: S.rounded
    },
    page: {
      type: Number,
      required: !0,
      validator: (l) => l > 0
    },
    count: {
      type: Number,
      required: !0,
      validator: (l) => l > 0
    },
    hidePrevNext: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hideFirstLast: {
      type: Boolean,
      required: !1,
      default: !1
    },
    siblingCount: {
      type: Number,
      required: !1,
      default: 1,
      validator: (l) => l >= 0
    },
    boundaryCount: {
      type: Number,
      required: !1,
      default: 1,
      validator: (l) => l >= 0
    },
    itemsPerPage: {
      type: Number,
      required: !1
    },
    itemsPerPageOptions: {
      type: Array,
      required: !1
    }
  },
  emits: ["update:page", "update:itemsPerPage"],
  setup(l, { emit: I }) {
    const L = I, e = l, i = E(1);
    F(
      () => e.page,
      (t) => {
        i.value = t;
      },
      { immediate: !0 }
    );
    const $ = E();
    function s(t) {
      i.value = t, L("update:page", t);
    }
    F(
      () => e.itemsPerPage,
      (t) => {
        $.value = t;
      },
      { immediate: !0 }
    );
    const O = u(() => e.itemsPerPageOptions && e.itemsPerPageOptions.length > 0);
    function _(t) {
      $.value = t, L("update:itemsPerPage", t);
    }
    const o = u(() => e.shape === S.squared), B = u(() => {
      switch (e.size) {
        case g.small:
        case g.sm:
          return "mock-button-sm";
        case g.tiny:
        case g.xs:
          return "mock-button-xs";
        default:
          return "mock-button-sm";
      }
    }), A = u(() => {
      switch (e.shape) {
        case S.squared:
          return "button-square";
        case S.rounded:
        default:
          return "";
      }
    }), D = u(() => {
      switch (e.color) {
        case w.brand:
          return "mock-button-brand";
        case w.primary:
        default:
          return "mock-button-primary";
      }
    }), M = u(() => {
      switch (e.size) {
        case g.small:
        case g.sm:
          return "";
        case g.tiny:
        case g.xs:
          return "input-xs";
        default:
          return "";
      }
    }), T = u(() => e.itemsPerPageOptions ? Math.max(...e.itemsPerPageOptions.map((d) => d.label.length)) > 2 ? "70px" : "60px" : void 0), v = u(() => {
      switch (e.variant) {
        case N.text:
          return U.text;
        case N.outlineSubtle:
        default:
          return U.outlineSubtle;
      }
    }), P = u(() => e.boundaryCount + e.siblingCount + 1), R = u(() => i.value - 1 <= P.value), W = u(() => {
      const t = i.value - 1;
      return C(1, t);
    }), V = u(() => i.value >= e.count - P.value), j = u(() => {
      const t = i.value + 1;
      return C(t, e.count);
    }), G = u(() => C(1, e.boundaryCount)), H = u(() => {
      let t = i.value - e.siblingCount;
      return V.value && (t = e.count - P.value - e.siblingCount), C(t, i.value - 1);
    }), J = u(() => {
      let t = i.value + e.siblingCount;
      return R.value && (t = P.value + e.siblingCount + 1), C(i.value + 1, t);
    }), K = u(() => C(e.count - e.boundaryCount + 1, e.count));
    return (t, d) => (r(), c("div", Z, [
      O.value ? (r(), c("span", ee, "Items per page")) : f("", !0),
      O.value ? (r(), n(Y, {
        key: 1,
        variant: "outline-light",
        size: "sm",
        options: l.itemsPerPageOptions,
        class: h([M.value]),
        style: X({ width: T.value }),
        "model-value": $.value,
        "onUpdate:modelValue": _,
        "aria-label": "items per page selector"
      }, null, 8, ["options", "class", "style", "model-value"])) : f("", !0),
      x("nav", ae, [
        l.hideFirstLast ? f("", !0) : (r(), n(m, {
          key: 0,
          disabled: i.value === 1,
          size: e.size,
          variant: v.value,
          square: o.value,
          icon: "lastpageLeft",
          onClick: d[0] || (d[0] = (a) => s(1)),
          "aria-label": "go to first page"
        }, null, 8, ["disabled", "size", "variant", "square"])),
        l.hidePrevNext ? f("", !0) : (r(), n(m, {
          key: 1,
          disabled: i.value === 1,
          size: e.size,
          variant: v.value,
          square: o.value,
          icon: "chevronLeft",
          onClick: d[1] || (d[1] = (a) => s(i.value - 1)),
          "aria-label": "go to previous page"
        }, null, 8, ["disabled", "size", "variant", "square"])),
        R.value ? (r(!0), c(p, { key: 2 }, k(W.value, (a) => (r(), n(m, {
          key: a,
          size: e.size,
          variant: v.value,
          square: o.value,
          onClick: (q) => s(a),
          "aria-label": `go to page ${a}`
        }, {
          default: y(() => [
            z(b(a), 1)
          ]),
          _: 2
        }, 1032, ["size", "variant", "square", "onClick", "aria-label"]))), 128)) : (r(), c(p, { key: 3 }, [
          (r(!0), c(p, null, k(G.value, (a) => (r(), n(m, {
            size: e.size,
            variant: v.value,
            square: o.value,
            key: a,
            onClick: (q) => s(a),
            "aria-label": `go to page ${a}`
          }, {
            default: y(() => [
              z(b(a), 1)
            ]),
            _: 2
          }, 1032, ["size", "variant", "square", "onClick", "aria-label"]))), 128)),
          x("div", {
            class: h(["mock-button", B.value])
          }, "...", 2),
          (r(!0), c(p, null, k(H.value, (a) => (r(), n(m, {
            key: a,
            size: e.size,
            variant: v.value,
            square: o.value,
            onClick: (q) => s(a),
            "aria-label": `go to page ${a}`
          }, {
            default: y(() => [
              z(b(a), 1)
            ]),
            _: 2
          }, 1032, ["size", "variant", "square", "onClick", "aria-label"]))), 128))
        ], 64)),
        x("div", {
          class: h(["mock-button", B.value, A.value, D.value])
        }, b(i.value), 3),
        V.value ? (r(!0), c(p, { key: 4 }, k(j.value, (a) => (r(), n(m, {
          key: a,
          size: e.size,
          variant: v.value,
          square: o.value,
          onClick: (q) => s(a),
          "aria-label": `go to page ${a}`
        }, {
          default: y(() => [
            z(b(a), 1)
          ]),
          _: 2
        }, 1032, ["size", "variant", "square", "onClick", "aria-label"]))), 128)) : (r(), c(p, { key: 5 }, [
          (r(!0), c(p, null, k(J.value, (a) => (r(), n(m, {
            key: a,
            size: e.size,
            variant: v.value,
            square: o.value,
            onClick: (q) => s(a),
            "aria-label": `go to page ${a}`
          }, {
            default: y(() => [
              z(b(a), 1)
            ]),
            _: 2
          }, 1032, ["size", "variant", "square", "onClick", "aria-label"]))), 128)),
          x("div", {
            class: h(["mock-button", B.value])
          }, "...", 2),
          (r(!0), c(p, null, k(K.value, (a) => (r(), n(m, {
            key: a,
            size: e.size,
            variant: v.value,
            square: o.value,
            onClick: (q) => s(a),
            "aria-label": `go to page ${a}`
          }, {
            default: y(() => [
              z(b(a), 1)
            ]),
            _: 2
          }, 1032, ["size", "variant", "square", "onClick", "aria-label"]))), 128))
        ], 64)),
        l.hidePrevNext ? f("", !0) : (r(), n(m, {
          key: 6,
          disabled: i.value === e.count,
          size: e.size,
          variant: v.value,
          square: o.value,
          icon: "chevronRight",
          onClick: d[2] || (d[2] = (a) => s(i.value + 1)),
          "aria-label": "go to next page"
        }, null, 8, ["disabled", "size", "variant", "square"])),
        l.hideFirstLast ? f("", !0) : (r(), n(m, {
          key: 7,
          disabled: i.value === e.count,
          size: e.size,
          variant: v.value,
          square: o.value,
          icon: "lastpageRight",
          onClick: d[3] || (d[3] = (a) => s(e.count)),
          "aria-label": "go to last page"
        }, null, 8, ["disabled", "size", "variant", "square"]))
      ])
    ]));
  }
});
export {
  se as default
};
